const typographyModalDocEmployee = {
  true: 'Registrar Nuevo Documento',
  false: 'Editar Documento'
};

export default typographyModalDocEmployee;
